(function(){
  if(window.__nycheRealGiftsLoaded)return;
  window.__nycheRealGiftsLoaded=true;
  const codes=[67791176204598,67791184658742,67791188164918,67791189770550,67791246229814,67791246852406,67791248163126,67791250325814];
  const giftIds=new Set(codes);
  const root=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
  const endpoint=(s)=>root+s;
  const isGift=(item)=>giftIds.has(Number(item.variant_id));
  let busy=false;
  let checkoutPending=false;
  let clearing=false;

  async function getCart(){
    const r=await fetch(endpoint('cart.js'),{credentials:'same-origin'});
    if(!r.ok)throw new Error('Could not read cart');
    return r.json();
  }
  function nonGiftCents(cart){
    return cart.items.reduce((total,item)=>total+(isGift(item)?0:item.final_line_price),0);
  }
  async function postCart(endpointName,payload){
    const r=await fetch(endpoint(endpointName),{
      method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(payload)
    });
    let result=await r.json();
    if(!r.ok||result.status>=400)throw new Error(result.description||result.message||'Cart update failed');
    return result;
  }
  async function changeLine(item,qty){
    return postCart('cart/change.js',{id:item.key,quantity:qty});
  }
  function getWidget(){return document.querySelector('[data-nyche-cart-rewards]');}
  function feedback(message,error){
    document.querySelectorAll('.nyche-rewards-feedback').forEach(el=>{
      el.textContent=message;el.classList.toggle('is-error',!!error);
    });
  }
  function preserveDrawer(){
    try{sessionStorage.setItem('nyche-reopen-cart','1');}catch(e){}
  }
  function reopenDrawer(){
    let requested=false;
    try{requested=sessionStorage.getItem('nyche-reopen-cart')==='1';sessionStorage.removeItem('nyche-reopen-cart');}catch(e){}
    if(!requested)return;
    setTimeout(()=>{let el=document.querySelector('cart-drawer');if(el&&!el.classList.contains('active')&&typeof el.open==='function'){el.open(document.querySelector('#cart-icon-bubble'));}},160);
  }
  async function addGift(variantId){
    if(busy)return;
    busy=true;
    feedback('Adding your mini gift…',false);
    document.querySelectorAll('.nyche-rewards-gifts input').forEach(x=>x.disabled=true);
    try{
      if(!giftIds.has(variantId))throw new Error('This gift option is unavailable.');
      let cart=await getCart();
      if(nonGiftCents(cart)<6500)throw new Error('Add $65 in regular items before claiming a mini gift.');
      const current=cart.items.filter(isGift);
      if(current.length===1&&Number(current[0].variant_id)===variantId&&current[0].quantity===1){
        feedback('✓ Your gift is already in the cart.',false);return;
      }
      // Remove a previously selected gift first. New variant inventory is checked by Shopify.
      for(const item of current)await changeLine(item,0);
      await postCart('cart/add.js',{items:[{id:variantId,quantity:1,properties:{'_Nyche Free Gift':'Yes'}}]});
      await postCart('cart/update.js',{attributes:{'Nyche Free Sample':''}});
      feedback('✓ Gift added! Applying your FREE discount…',false);
      preserveDrawer();
      const target=window.location.pathname+window.location.search;
      window.location.assign(root+'discount/FREE?redirect='+encodeURIComponent(target));
    }catch(e){
      feedback(e.message||'Unable to add that gift. Please try again.',true);
      document.querySelectorAll('.nyche-rewards-gifts input').forEach(x=>{x.disabled=x.closest('.is-out-of-stock')!==null;});
    }finally{busy=false;}
  }

  document.addEventListener('change',e=>{
    const input=e.target;
    if(!(input instanceof HTMLInputElement)||!input.matches('[data-nyche-cart-rewards] input[data-nyche-gift-variant]'))return;
    if(input.disabled)return;
    addGift(Number(input.dataset.nycheGiftVariant));
  });


  // Save the explicit terms acknowledgement on Shopify's cart and ensure the
  // theme checkout buttons cannot bypass it, including the FREE code redirect.
  // RT Terms app may also add its own consent control if its drawer placement is set.
  let nycheTermsSaving=false;
  const nycheCheckoutSelector='button[name="checkout"],#CartDrawer-Checkout,#checkout';
  function getTermsCheckbox(button){
    const formId=button?.getAttribute('form')||button?.closest('form')?.id;
    const wrap=Array.from(document.querySelectorAll('[data-nyche-terms]')).find(el=>
      el.dataset.formId===formId
    )||document.querySelector('[data-nyche-terms]');
    return wrap?.querySelector('[data-nyche-terms-checkbox]')||null;
  }
  function rejectWithoutTerms(event,button){
    const checkbox=getTermsCheckbox(button);
    if(!checkbox)return false;
    const wrapper=checkbox.closest('[data-nyche-terms]');
    const message=wrapper?.querySelector('[data-nyche-terms-message]');
    if(checkbox.checked&&!nycheTermsSaving)return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    if(message){
      message.textContent=nycheTermsSaving
        ? 'Saving your agreement. Please try checkout again.'
        : 'Please agree to our Terms & Conditions before checkout.';
    }
    checkbox.focus({preventScroll:true});
    checkbox.scrollIntoView({behavior:'smooth',block:'center'});
    return true;
  }
  document.addEventListener('click',event=>{
    const button=event.target.closest?.(nycheCheckoutSelector);
    if(button)rejectWithoutTerms(event,button);
  },true);
  document.addEventListener('submit',event=>{
    if(!event.target.matches('#cart,#CartDrawer-Form'))return;
    const button=document.querySelector('button[form="'+event.target.id+'"][name="checkout"]')
      ||event.target.querySelector('button[name="checkout"]');
    if(button)rejectWithoutTerms(event,button);
  },true);
  document.addEventListener('change',async event=>{
    const input=event.target;
    if(!input.matches?.('[data-nyche-terms-checkbox]'))return;
    const wrapper=input.closest('[data-nyche-terms]');
    const message=wrapper?.querySelector('[data-nyche-terms-message]');
    nycheTermsSaving=true;
    if(message)message.textContent='Saving your agreement…';
    try{
      const accepted=input.checked;
      const r=await postCart('cart/update.js',{attributes:{
        'Nyche Terms Accepted':accepted?'Yes':'No',
        'Nyche Terms Accepted At':accepted?new Date().toISOString():''
      }});
      document.querySelectorAll('[data-nyche-terms-checkbox]').forEach(x=>x.checked=accepted);
      if(message)message.textContent='';
    }catch(e){
      input.checked=false;
      if(message)message.textContent='Unable to save your agreement. Please try again.';
    }finally{nycheTermsSaving=false;}
  });

  // Ensure gift discounts are applied even if shopper removes and re-adds products,
  // and on a direct click of the normal cart checkout button.
  document.addEventListener('click',e=>{
    const button=e.target.closest?.('button[name="checkout"],#CartDrawer-Checkout,#checkout');
    if(!button||!getWidget()||checkoutPending)return;
    const w=getWidget();
    if(Number(w.dataset.nycheTotal)<6500 || !Number(w.dataset.nycheCurrentVariant))return;
    e.preventDefault();e.stopImmediatePropagation();
    checkoutPending=true;
    window.location.assign(root+'discount/FREE?redirect='+encodeURIComponent('/checkout'));
  },true);

  // Cart form submission also triggers during keyboard checkout.
  document.addEventListener('submit',e=>{
    if(!e.target.matches('#CartDrawer-Form,#cart')||checkoutPending)return;
    const w=getWidget();
    if(!w||Number(w.dataset.nycheTotal)<6500||!Number(w.dataset.nycheCurrentVariant))return;
    e.preventDefault();e.stopImmediatePropagation();
    checkoutPending=true;
    window.location.assign(root+'discount/FREE?redirect='+encodeURIComponent('/checkout'));
  },true);

  async function cleanIneligibleGift(){
    if(clearing||busy)return;
    clearing=true;
    try{
      const cart=await getCart();
      const gifts=cart.items.filter(isGift);
      if(!gifts.length||nonGiftCents(cart)>=6500)return;
      for(const item of gifts)await changeLine(item,0);
      await postCart('cart/update.js',{attributes:{'Nyche Free Sample':''}});
      if(document.querySelector('cart-drawer.active'))preserveDrawer();
      window.location.reload();
    }catch(e){console.warn('Nyche gift eligibility update failed',e);}
    finally{clearing=false;}
  }
  function initialize(){
    reopenDrawer();
    cleanIneligibleGift();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();

  // Animate cart goal progress when Shopify swaps cart sections during quantity
  // changes, add-to-cart, or gift selection. Never require a page reload.
  let nychePreviousProgress=null;
  const trackedWidgets=new WeakSet();
  function nycheAnimateProgress(widget) {
    if(!widget||trackedWidgets.has(widget))return;
    trackedWidgets.add(widget);
    const fill=widget.querySelector('.nyche-rewards-progress-fill');
    const track=widget.querySelector('.nyche-rewards-progress');
    if(!fill||!track)return;
    const cents=Math.max(0,Number(widget.dataset.nycheTotal)||0);
    const goal=Math.max(1,Number(widget.dataset.nycheProgressGoal)||6500);
    const target=Math.min(100,cents/goal*100);
    const previous=nychePreviousProgress===null?0:nychePreviousProgress;
    fill.style.width=previous.toFixed(3)+'%';
    track.setAttribute('aria-valuenow',String(Math.round(target)));
    // Force a separate paint frame before transitioning to the new target.
    requestAnimationFrame(()=>{
      requestAnimationFrame(()=>{
        if(!widget.isConnected)return;
        fill.style.width=target.toFixed(3)+'%';
        nychePreviousProgress=target;
      });
    });
  }
  
  // A single visible gift at a time. Re-initializes when Shopify updates cart sections.
  const nycheInitializedCarousels=new WeakSet();
  function nycheCarouselSetup(carousel){
    if(nycheInitializedCarousels.has(carousel))return;
    nycheInitializedCarousels.add(carousel);
    const track=carousel.querySelector('[data-nyche-gift-track]');
    const slides=Array.from(track?.querySelectorAll('.nyche-gift-slide')||[]);
    const label=carousel.querySelector('[data-nyche-gift-position]');
    const prev=carousel.querySelector('[data-nyche-gift-prev]');
    const next=carousel.querySelector('[data-nyche-gift-next]');
    if(!track||!slides.length)return;
    let index=Math.max(0,slides.findIndex(slide=>slide.querySelector('input:checked')));
    function updatePosition(n){
      index=Math.max(0,Math.min(slides.length-1,n));
      if(label)label.textContent=(index+1)+' / '+slides.length;
      if(prev)prev.disabled=slides.length<=1;
      if(next)next.disabled=slides.length<=1;
    }
    function scrollToGift(n,behavior='smooth'){
      const target=(n+slides.length)%slides.length;
      const x=slides[target].offsetLeft-slides[0].offsetLeft;
      track.scrollTo({left:x,behavior});
      updatePosition(target);
    }
    updatePosition(index);
    if(index>0)requestAnimationFrame(()=>scrollToGift(index,'instant'));
    prev?.addEventListener('click',()=>scrollToGift(index-1));
    next?.addEventListener('click',()=>scrollToGift(index+1));
    let ticking=false;
    track.addEventListener('scroll',()=>{
      if(ticking)return;
      ticking=true;
      requestAnimationFrame(()=>{
        ticking=false;
        let nearest=0,dist=Infinity;
        for(let i=0;i<slides.length;i++){
          const offset=Math.abs((slides[i].offsetLeft-slides[0].offsetLeft)-track.scrollLeft);
          if(offset<dist){nearest=i;dist=offset;}
        }
        updatePosition(nearest);
      });
    },{passive:true});
  }
  function nycheInitializeCarousels(){
    document.querySelectorAll('[data-nyche-gift-carousel]').forEach(nycheCarouselSetup);
  }

  function nycheFindProgress() {
    document.querySelectorAll('[data-nyche-cart-rewards]').forEach(nycheAnimateProgress);
    nycheInitializeCarousels();
  }
  const nycheProgressObserver=new MutationObserver(nycheFindProgress);
  function nycheStartProgress() {
    nycheFindProgress();
    nycheProgressObserver.observe(document.body,{subtree:true,childList:true});
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',nycheStartProgress,{once:true});
  }else nycheStartProgress();

})();